export default __webpack_public_path__ + "static/media/gallery-image-10.07fa03c9.jpg";